import React from 'react'
import { Platform, View } from 'react-native'
import { alignBrowserWidth } from '../../../../../utils/browser'
import { ShadowContainer } from '../../../../../@ui/containers/cards/shadow.container'
import { useKeyboard } from '../../../../../hooks/keyboard.hook'

interface FixBottomBarProps {
  height: number
  children: React.ReactNode
}

export function FixBottomBar({ height, children }: FixBottomBarProps) {
  const { keyboardDisplayed, keyboardHeight } = useKeyboard()
  const bottomOffset = keyboardDisplayed ? keyboardHeight : 0

  if (height === 0) {
    return null
  }
  return (
    <ShadowContainer
      shadowType="top"
      style={{
        height,
        position: Platform.OS === 'web' ? ('fixed' as any) : 'absolute',
        bottom: bottomOffset,
        left: 0,
        right: 0,
        width: '100%',
        alignSelf: 'center',
        zIndex: 1000,
      }}
    >
      <View
        style={{
          width: alignBrowserWidth(),
          alignSelf: 'center',
        }}
      >
        {children}
      </View>
    </ShadowContainer>
  )
}
